import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField/TextField";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {Translate} from "../../../../config/Translate";
import Grid from "@material-ui/core/Grid";
import SubTitle from "../../../components/elements/SubTitle";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import SingleFileChooser from "../../fileManager/Components/SingleFileChooser";
import ProtectedFileUploader from "../../fileManager/Components/ProtectedFileUploader";
import {defaultVariabls} from "../../../../config";
import Button from "@material-ui/core/Button/Button";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import Divider from "@material-ui/core/Divider/Divider";

class EpisodeMaker extends React.Component {
    state = {
        episodes: !!this.props.episodes.length ? this.props.episodes :
            [
                {
                    name: '',
                    description:'',
                    thumbnail:'',
                    file:''
                }
            ],
        can_add:false
    };
    classes = this.props.classes;

    async handleInput(index,input,field){
        let {episodes} = this.state;
        episodes[index][field] = input;
        await this.setState({
            episodes
        })
        await this.props.handleEpisodes(episodes);
    }
    handleAddNewEP(){
        let {episodes} = this.state;
        if(!!episodes[episodes.length - 1].file){
            episodes.push(
                {
                    name: '',
                    description:'',
                    thumbnail:'',
                    file:''
                }
            )
            this.setState({
                episodes
            })
        }else{
            this.props.enqueueSnackbar(Translate.pleaseAddPreviousEpFile, {
                variant: 'warning',
            });
        }

    }
    render(){
        let {episodes} = this.state;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubTitle align="left">{Translate.episodes}</SubTitle>
                </Grid>
                {
                    episodes.map((episode,index) => (
                        <Grid item xs={12} key={index}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Divider/>
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <ProtectedFileUploader
                                                index={index}
                                                handleFile={(file) => this.handleInput(index,file,'file')}
                                                title={Translate.epAudioFile}
                                                type="audio"
                                                variant="outlined"
                                            />
                                        </Grid>
                                        {
                                            !!episode.file &&
                                            <Grid item xs={12}>
                                                <audio controls>
                                                    <source src={`${defaultVariabls.website}/file/get-private/${episode.file.id}`} type={`audio/${episode.file.extension}`} />
                                                    Your browser does not support the audio element.
                                                </audio>
                                            </Grid>
                                        }
                                        <Grid item xs={12}>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                variant="outlined"
                                                label={Translate.epName}
                                                type="text"
                                                value={episode.name}
                                                onChange={(e) => this.handleInput(index,e.target.value,'name')}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                variant="outlined"
                                                label={Translate.epDescription}
                                                type="text"
                                                multiline
                                                minRows={2}
                                                value={episode.description}
                                                onChange={(e) => this.handleInput(index,e.target.value,'description')}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <SubTitle>{Translate.epThumbnail}</SubTitle>
                                    <SingleImageChooser
                                        primary
                                        onChange={(thumbnail) => this.handleInput(index,thumbnail,'thumbnail')}
                                        initial={episode.thumbnail}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ))
                }
                <Grid item xs={12} style={{textAlign:"center"}}>
                    <Button
                        color="secondary"
                        size="small"
                        variant="contained"
                        onClick={() => this.handleAddNewEP()}
                        startIcon={<AddRoundedIcon/>}
                    >
                        {Translate.addNewEpisode}
                    </Button>
                </Grid>
            </Grid>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(EpisodeMaker)));